// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 96) return "assets/js/vendors.bundle.js";
	// return url for filenames based on template
	return chunkId + ".js";
};